import { render } from "./SchoolTable.vue?vue&type=template&id=64f18ef9"
import script from "./SchoolTable.vue?vue&type=script&lang=js"
export * from "./SchoolTable.vue?vue&type=script&lang=js"

import "./SchoolTable.vue?vue&type=style&index=0&id=64f18ef9&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__